'use client'

import { getFingerprint } from '@marketplace-web/domain/audit'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import {
  landingPageEvent,
  HoVBottomSectionModel,
  HoVLandingPageEvent,
} from '@marketplace-web/domain/marketing-landing-page-data'

type Props = { data: HoVBottomSectionModel }

export const HoVBottomSection = ({ data: { title, ctaText, ctaUrl, description } }: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.BottomCtaClick,
        target: ClickableElement.CtaRedirect,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="hov__bottom-section" className="hov__bottom-section">
      <h3 className="hov__bottom-headline">{title}</h3>
      <p className="hov__bottom-description">{description}</p>
      <a
        role="button"
        href={ctaUrl}
        className="hov__bottom-cta"
        data-testid="hov__bottom-cta"
        onClick={handleOnCtaClick}
      >
        {ctaText}
      </a>
    </section>
  )
}
